import { FASTElement as p, attr as o, observable as d } from "@microsoft/fast-element";
import { iconStyles as v } from "./icon.styles.js";
import { iconTemplate as y } from "./icon.template.js";
import { designTokens as f } from "../design-tokens.js";
var m = Object.defineProperty, n = (l, t, i, c) => {
  for (var s = void 0, a = l.length - 1, h; a >= 0; a--)
    (h = l[a]) && (s = h(t, i, s) || s);
  return s && m(t, i, s), s;
}, e;
const r = (e = class extends p {
  constructor(t, i) {
    super(), this.variant = "outline", this.color = void 0, this._type = "outline", t && (this.name = t), i && (this.variant = i);
  }
  variantChanged() {
    this.invalidateType();
  }
  invalidateSize() {
    this.size || (this.size = `var(${f.iconSize.md.cssCustomProperty})`);
  }
  //TODO when ::slotted(nova-icon)::part(control) is supported, apply the style to the control directly
  // https://github.com/w3c/csswg-drafts/issues/3896
  sizeChanged() {
    this.invalidateSize(), this.style.width = this.size, this.style.height = this.size;
  }
  connectedCallback() {
    super.connectedCallback(), e._resizeObserver.observe(this), this.invalidateSize();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), e._resizeObserver.unobserve(this);
  }
  invalidateType() {
    this.clientWidth <= 16 || this.clientHeight <= 16 ? this._type = "micro" : this.clientWidth < 24 || this.clientHeight < 24 ? this._type = "mini" : this._type = this.variant;
  }
  static onResize(t) {
    for (const i of t)
      i.target.invalidateType();
  }
}, e._resizeObserver = new ResizeObserver(e.onResize), e.definition = {
  name: "icon",
  template: () => y,
  styles: () => v
}, e);
n([
  o
], r.prototype, "name");
n([
  o
], r.prototype, "variant");
n([
  o
], r.prototype, "color");
n([
  o
], r.prototype, "size");
n([
  d
], r.prototype, "_type");
let C = r;
export {
  C as Icon
};
